import React from 'react';

import { NewSubdomainContainer, SubdomainListContainer } from '../containers';

const SubdomainsComponent = () => (
  <div className="subdomains">
    <NewSubdomainContainer />
    <SubdomainListContainer />
  </div>
);

export default SubdomainsComponent;
